module.exports = __webpack_public_path__ + "static/media/desktopCharlieAddIcon.2aab5a6c.svg";